import React from "react";
import { useLocation } from "react-router-dom";
import LogoutIcon from "@Components/Icons/Logout";
import NavDashboard from "@Components/Icons/Nav/Dashboard";
import ProfileIcon from "@Components/Icons/Profile";
import Tender from "@Components/Icons/Tender";
import Usage from "@Components/Icons/Usage";
import PrimaryNav from "@Components/PrimaryNav";
import GetPath, { GetReplacements } from "@Helpers/GetPath";
import IsPathMatch from "@Helpers/IsPathMatch";
import Globe02 from "@Components/Icons/Globe02";
import { LOGOUT, MY_ACCOUNT, MY_ORGANISATION, ROOT, TENDERS, USAGES, VIEW_RESPONSES, } from "@Shared/Paths/Customer";
import styles from "./index.module.scss";
const mainRoutes = [
    {
        path: ROOT,
        name: "Dashboard",
        icon: React.createElement(NavDashboard, { className: styles.icon }),
        exact: true,
    },
    {
        path: TENDERS,
        name: "Tenders",
        icon: React.createElement(Tender, { className: styles.icon }),
        filter: (path, company) => company?.canCreateTender,
    },
    {
        path: USAGES,
        name: "Sensabill",
        icon: React.createElement(Usage, { className: styles.icon }),
        filter: (path, company) => company?.canViewSensabill,
    },
    {
        path: MY_ORGANISATION,
        name: "My Organisation",
        icon: React.createElement(Globe02, { className: styles.icon }),
    },
    {
        path: MY_ACCOUNT,
        name: "My Account",
        icon: React.createElement(ProfileIcon, { className: styles.icon }),
        filter: (path, company) => company?.viewAll,
    },
];
const bottomRoutes = [
    {
        path: LOGOUT,
        name: "Logout",
        icon: React.createElement(LogoutIcon, { className: styles.icon }),
        exact: true,
    },
];
const filterRoutes = (routes, pathname, company) => routes
    .filter(({ filter = (path, customer) => !!path && !!customer, }) => filter(pathname, company))
    .map((route) => {
    const replacements = GetReplacements(route.path, pathname);
    return { ...route, path: GetPath(route.path, ...replacements) };
});
export default (props) => {
    const location = useLocation();
    const pathname = location.pathname;
    if (IsPathMatch(pathname, VIEW_RESPONSES)) {
        return React.createElement(React.Fragment, null);
    }
    const mainRoutesFiltered = filterRoutes(mainRoutes, pathname, props.company);
    const bottomRoutesFiltered = bottomRoutes
        .filter(({ filter = (path, company) => !!path && !!company, }) => filter(pathname, props.company))
        .map((route) => {
        const replacements = GetReplacements(route.path, pathname);
        return { ...route, path: GetPath(route.path, ...replacements) };
    });
    return (React.createElement(PrimaryNav, { linkSections: [{ links: mainRoutesFiltered }], bottomLinks: bottomRoutesFiltered, variant: "sectioned" }));
};
